'use client';

import { useEffect, useRef } from 'react';
import {
  FIRST_TOUCH_KEY,
  LAST_TOUCH_KEY,
  hasAttribution,
  mergeTouch,
  readAttributionFromSearch,
  readStoredTouch,
} from '@/shared/lib/attribution/first-touch';

export function AttributionProvider() {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (typeof window === 'undefined') return;

    const attribution = readAttributionFromSearch(new URLSearchParams(window.location.search));
    if (!hasAttribution(attribution)) return;

    const touch = { ...attribution, captured_at: new Date().toISOString() };
    const lastTouch = mergeTouch(touch, readStoredTouch(LAST_TOUCH_KEY));

    try {
      if (!window.localStorage.getItem(FIRST_TOUCH_KEY)) {
        window.localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(touch));
      }
      window.localStorage.setItem(LAST_TOUCH_KEY, JSON.stringify(lastTouch));
    } catch {
      // Safari private mode / quota exceeded — attribution is best-effort.
    }
  }, []);

  return null;
}
